import {type Module} from 'vuex';
import mutations from './mutations';

// state
const state: IPersonalDashboardState = {
    isOpen: false,
    needs: false,
};

// module
const personalDashboard: Module<IPersonalDashboardState, RootState> = {
    namespaced: true,
    state,
    mutations
};

export {state};

export default personalDashboard;